import { CSSProperties } from 'react';
import { makeStyles, createStyles } from '@material-ui/core/styles';

import { variables } from '@styles';

/**
 * SampleTemplate component styles
 * @returns {Function}
 */

const rightLineStyles: CSSProperties = {
  position: 'absolute',
  width: variables.borderWidth.xl,
  height: '100%',
  borderRight: `solid ${variables.borderWidth.xl} ${variables.color.primary.mainPurple}`,
  top: 0,
  left: 'calc(100% - 0.4rem)',
};

const rigthLineBeforeStyles: CSSProperties = {
  content: "''",
  position: 'absolute',
  top: '50%',
  transform: 'translateY(-50%)',
  left: '-0.8rem',
  width: 0,
  height: 0,
  borderStyle: 'solid',
  borderWidth: '0.8rem 0.8rem 0.8rem 0',
  borderColor: `transparent ${variables.color.primary.mainPurple} transparent transparent`,
};

export const useStyles = makeStyles(() =>
  createStyles({
    sampleTemplate: {
      // height: '100%',
      height: '100%', //'calc(100% - 6.4rem)',
      overflowY: 'scroll',
      overflowX: 'hidden',
      display: 'flex',
      flexDirection: 'column',
      flex: '1 1 auto',
      position: 'relative',
    },

    moduleEditorClosed: {
      height: 'calc(100% - 10rem)',
    },

    moduleHeaderPlaceholder: {
      '&&': {
        flexShrink: 0,
        height: '10rem', //'8.8rem',
        maxHeight: '10rem', //'8.8rem',
        minHeight: '10rem', //'8.8rem',
        // position: 'sticky',
        top: 0,
      },
    },

    rightLine: {
      ...(rightLineStyles as { [key: string]: string }),

      '&::before': {
        ...rigthLineBeforeStyles,
      },
    },

    rightLineGray: {
      ...(rightLineStyles as { [key: string]: string }),
      borderRight: `solid ${variables.borderWidth.xl} ${variables.color.primary.halfMediumGray}`,

      '&::before': {
        ...rigthLineBeforeStyles,
        borderColor: `transparent ${variables.color.primary.halfMediumGray} transparent transparent`,
      },
    },

    content: {
      height: '100%',
      position: 'relative',
    },

    iframeWrapper: {
      alignItems: 'center',
      display: 'flex',
      flexDirection: 'column',

      height: '100%',
      transition: 'opacity 0.4s',

      '&[data-loaded="false"]': {
        opacity: variables.opacity.medium,
        pointerEvents: 'none',
      },

      '&[data-loaded="true"]': {
        opacity: variables.opacity.full,
        pointerEvents: 'initial',
      },
    },

    iframe: {
      borderRadius: '2rem',
      // marginLeft: '50%',
      // transform: 'translateX(-50%)',
    },

    moduleModalWrapper: {
      position: 'absolute',
      backgroundColor: 'rgba(0, 0, 0, 0.6)',
      height: '100vh',
      zIndex: 1,
      marginRight: '24.5rem',
      padding: '7.8rem 4.8rem 0 4.8rem',
    },

    moduleContent: {
      position: 'relative',
      width: '60rem',
    },

    closeBtn: {
      width: '3rem',
      height: '3rem',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      position: 'absolute',
      border: `${variables.borderWidth.md} solid ${variables.color.primary.lightGrayDarker}`,
      borderRadius: variables.borderRadius.sm,
      background: variables.color.primary.white,
      top: '-6rem',
      right: '0rem',
      cursor: 'pointer',
    },

    trashCanBtn: {
      bottom: 0,
      cursor: 'pointer',
      height: '1.6rem',
      pointerEvents: 'all',
      position: 'absolute',
      right: '-2.8rem',
      width: '2.6rem',
      zIndex: 2200000,

      '&:hover': {
        '& SVG PATH': {
          // fill: variables.colorV2.button.default.border.default,
          stroke: variables.colorV2.button.default.border.active,
        },
      },
    },

    trashCanBtnInner: {
      // alignItems: 'center',
      backgroundColor: 'transparent',
      borderRadius: '.4rem',
      bottom: 0,
      color: variables.color.primary.white,
      // display: 'flex',
      // fontFamily: 'Manrope, sans-serif',
      height: '1.6rem',
      padding: '0 5px',
      position: 'absolute',
      // right: '-2.5rem',
    },

    baseOverlay: {
      borderStyle: 'solid',
      borderWidth: '0 4px 0 0',
      boxSizing: 'content-box',
      display: 'none',
      // marginLeft: '50%',
      pointerEvents: 'none',
      position: 'absolute',
      // transform: 'translateX(-50%)',
      zIndex: 10000,
      '&::after': {
        borderStyle: 'solid',
        borderWidth: '10px',
        content: '""',
        position: 'absolute',
        right: '-1px',
        top: '50%',
        transform: 'translateY(-50%)',
        zIndex: 10001,
      },
    },

    hoverOverlay: {
      borderColor: variables.colorV2.contentModule.border.hover,
      '&::after': {
        borderColor: `transparent ${variables.colorV2.contentModule.border.hover} transparent transparent`,
      },
    },

    activeOverlay: {
      borderColor: variables.colorV2.contentModule.border.active,
      '&::after': {
        borderColor: `transparent ${variables.colorV2.contentModule.border.active} transparent transparent`,
      },
    },
  }),
);
